import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import DiscographyMasonry from "./components/DiscographyMasonry";
import AudioPortfolio from "./components/AudioPortfolio";
import Videos from "./components/Videos";
import Services from "./components/Services";
import Shop from "./components/Shop";
import Legacy from "./components/Legacy";
import Footer from "./components/Footer";
import ServiceDetail from "./pages/ServiceDetail";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import MerchandisingPage from "./pages/MerchandisingPage";

const Home = () => {
  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <DiscographyMasonry />
      <AudioPortfolio />
      <Videos />
      <Services />
      <Shop />
      <Legacy />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/service/:slug" element={<ServiceDetail />} />
          <Route path="/merchandising" element={<MerchandisingPage />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
